import React from "react";
import loadingIcon from "../images/loading-icon.gif"

function Spinner(props, ref) {
  const { displayLoadingText = false,padding = 'p-4' } = props;
  return (
    <div ref={ref} data-testid="spinner" className={`${padding} text-center`}>
      <img src={loadingIcon} alt="loading" />
      <div>{displayLoadingText ? `${displayLoadingText}...` : ""}</div>
    </div>
  );
}

export default React.forwardRef(Spinner);
